import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../stores/store";
import {
  setCurrentSpecimen,
  clearCurrentSpecimen,
} from "../../../stores/specimens";
import {
  goToNextCollection,
  goToPreviousCollection,
} from "../../../stores/collection";
import {
  fetchSpecimensByCollectionId,
  updateSpecimen,
} from "../../../stores/specimens/actions";
import { useNavigate } from "react-router";
import { useWebServer } from "../../../providers";
import { ROUTES } from "../../../config/routes";
import { Grid, Box, IconButton, LinearProgress } from "@mui/material";
import "./index.css";
import HeadLine from "../../../components/HeadLine";
import { ArrowBack } from "@mui/icons-material";
import SpecimenForm from "../../../components/SpecimenForm";
import { SpecimenFormData, Specimen } from "../../../types";
import ImageCard from "./ImageCard";
import { selectSelectedCollection } from "../../../stores/collection";
import _ from "lodash";

const SpecimenGallery = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { sendRequest } = useWebServer();
  const { allSpecimens } = useAppSelector((state) => state.specimens);
  const selectedCollection = useAppSelector(
    (state) => state.collections.selectedCollection
  );
  const selectedSpecimen = useAppSelector(
    (state) => state.specimens.currentSpecimen
  );
  const loading = useAppSelector((state) => {
    const selectedId = state.collections.selectedCollection?.id || "";
    return state.specimens.allSpecimens[selectedId]?.loading || false;
  });
  const curCollectionSpecimenCount = useAppSelector((state) => {
    const selectedId = state.collections.selectedCollection?.id || "";
    const count = state.specimens.allSpecimens[selectedId]?.count;

    return count === undefined ? -1 : count;
  });

  const gridRef = React.useRef<HTMLDivElement>(null);
  const [page, setPage] = useState<number>(0);
  const [currentSpecimens, setCurrentSpecimens] = useState<Specimen[]>([]);

  const handleSpecimenSubmit = (
    specimenId: string,
    collectionId: string,
    data: SpecimenFormData
  ) => {
    dispatch(updateSpecimen({ sendRequest, specimenId, data, collectionId }));
  };

  useEffect(() => {
    if (!selectedCollection?.id) {
      navigate(ROUTES.HOME);
    }
  }, [selectedCollection, navigate]);

  useEffect(() => {
    if (selectedCollection?.id) {
      if (!allSpecimens?.[selectedCollection?.id || ""]?.specimens?.length) {
        setCurrentSpecimens([]);
        setPage(0);
        if (curCollectionSpecimenCount === -1) {
          dispatch(
            fetchSpecimensByCollectionId({
              sendRequest,
              collectionId: selectedCollection.id,
              page: 0,
              pageSize: 40,
            })
          );
        }
      } else {
        setCurrentSpecimens(
          allSpecimens?.[selectedCollection?.id || ""]?.specimens || []
        );
      }
    }
    // eslint-disable-next-line
  }, [dispatch, selectedCollection, sendRequest, allSpecimens]);

  const handleSpecimenClick = (specimen: Specimen) => {
    console.log("what happen to me", specimen);
    dispatch(setCurrentSpecimen(specimen));

    setTimeout(() => {
      if (gridRef.current) {
        const selectedElement = gridRef.current.querySelector(
          `[data-item-id="${specimen.id}"]`
        );
        if (selectedElement) {
          selectedElement.scrollIntoView({
            behavior: "smooth", // For smooth scrolling
            block: "center", // Align to the center vertically
          });
        }
      }
    }, 0);
  };

  useEffect(() => {
    const fetchItems = async () => {
      if (!selectedCollection) {
        return;
      }
      dispatch(
        fetchSpecimensByCollectionId({
          sendRequest,
          collectionId: selectedCollection.id,
          page: page,
          pageSize: 40,
        })
      );
    };

    fetchItems();
    // eslint-disable-next-line
  }, [page]);

  const handleScroll = () => {
    if (gridRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = gridRef.current;
      if (scrollTop + clientHeight >= scrollHeight && !loading) {
        setPage((prevPage) => prevPage + 1);
      }
    }
  };

  //handle collection navigation
  const collection = useAppSelector(selectSelectedCollection);
  const collections = useAppSelector((state) => state.collections.collections);
  const collectionCount = useAppSelector((state) => state.collections.count);
  const [curIndex, setCurIndex] = useState<number>(0);
  useEffect(() => {
    const curIndex = _.findIndex(collections, collection);
    setCurIndex(curIndex);
  }, [collections, collection]);

  return (
    <div className="gallery-specimens">
      <div className="btn-go-back-collections">
        <IconButton>
          <ArrowBack
            color="primary"
            onClick={() => {
              window.history.back();
            }}
          />
        </IconButton>
      </div>
      <Box className="gallery-headline">
        <HeadLine
          value={selectedCollection?.displayName || ""}
          handleGoBack={
            curIndex > 0 ? () => dispatch(goToPreviousCollection()) : undefined
          }
          handleGoNext={
            curIndex + 1 !== collectionCount
              ? () => dispatch(goToNextCollection())
              : undefined
          }
          showNav={true}
        />
      </Box>

      <Grid container sx={{
        boxShadow: 3, // MUI predefined shadow level (1–24)
        borderRadius: 2, // Optional: smooth corners
        p: 2 // Optional: padding
      }}
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                e.preventDefault();
                dispatch(clearCurrentSpecimen());
              }}
      >
        <Grid
          size="grow"
          onClick={(e: React.MouseEvent<HTMLDivElement>) => {
            e.preventDefault();
            dispatch(clearCurrentSpecimen());
          }}
        >
          {loading && <LinearProgress />}
          <Box
            ref={gridRef}
            className="grid-specimens"
            sx={{ width: "100%" }}
            onScroll={handleScroll}
          >
            <Grid
              container
              spacing={4}
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {currentSpecimens.map((specimen) => (
                <ImageCard
                  specimen={specimen}
                  selectedSpecimen={selectedSpecimen}
                  handleSpecimenClick={handleSpecimenClick}
                />
              ))}
            </Grid>
          </Box>
        </Grid>
        {selectedSpecimen && (
          <Grid size={4}>
            <div className="place-holder-form-specimen">
              <SpecimenForm
                specimen={selectedSpecimen}
                onSubmit={handleSpecimenSubmit}
              />
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default SpecimenGallery;
